<template>
    <div id="app">
        <page-header></page-header>
        <router-view/>
        <page-footer></page-footer>
    </div>
</template>

<script type="text/babel">
    import PageHeader from './components/PageHeader'
    import PageFooter from './components/PageFooter'

    export default {
        name: 'app',
        components: {
            "PageHeader": PageHeader,
            "PageFooter": PageFooter
        },
        data () {
            return {

            }
        },
        methods: {
            handleSelect(index){
                console.log(index)
                this.$root.activeIndex = index
            },
            handleOpen(){},
            handleClose(){}
        }
    }
</script>

<style lang="postcss">
@import './assets/common.css';
body{
    margin:0;
    padding: 0;
}
#app {
    font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
.hello{/* just for demo */
    text-align: center;
}
.main-container {
    @apply --centerWidth;
}

.info-table {
    width: 100%;
    font-size: 14px;
    border-collapse: collapse;
    border: 1px solid #d9d9d9;
    color: #333;
    & th {
        background-color: #f5f5f5;
        border: 1px solid #d9d9d9;
        padding: 12px 0;
        & b {
            color: red;
        }
    }
    & td {
        border: 1px solid #d9d9d9;
        text-align: center;
        padding: 12px;
        word-break: break-all;
    }
}
.break-word{
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
}
.edit-btn{
    color: var(--greenColor);
    cursor:pointer;
    text-decoration: underline;
}
.delete-btn{
    color: var(--redColor);
    cursor:pointer;
    text-decoration: underline;
}

 .el-message-box__message{
     white-space: normal;
     text-align: center;
 }
.el-upload-list__item .el-icon-upload-success {
    font-size: 18px;
}
.el-upload__tip .redTip {
    color: #ff0305;
}
</style>



// WEBPACK FOOTER //
// src/App.vue